import React from "react";
import Chip from "@mui/material/Chip";
import { WebSocketStatus } from "../../../../../hooks/useNepalPayWSS";

interface WebSocketStatusChipProps {
  status: WebSocketStatus;
}

const statusMap: Record<
  WebSocketStatus,
  { label: string; color: "default" | "primary" | "success" | "error" | "warning" | "info" }
> = {
  DISCONNECTED: { label: "Disconnected", color: "default" },
  CONNECTING: { label: "Connecting", color: "warning" },
  CONNECTED: { label: "Connected", color: "success" },
  ERROR: { label: "Error", color: "error" }
};

const WebSocketStatusChip: React.FC<WebSocketStatusChipProps> = ({ status }) => {
  const { label, color } = statusMap[status];
  return <Chip label={label} color={color} size="small" />;
};

export default WebSocketStatusChip;
